import { TableCell, TableRow, Typography, useTheme } from "@mui/material";
import { Box } from "@mui/system";
import { getStatusLabel } from "src/Utils/Combined";

import { useState } from "react";
import TableActions from "src/common/TableActions";
import { useAuthContext } from "src/components/Context/AuthContext/AuthContext";
import { useApiMutation } from "src/hooks/useApiMutation";
import { useValidImage } from "src/hooks/useValidImage";
import { IGuest } from "src/Types/module/guestAndSpeaker/type/guestAndSpeaker";
type IProps = {
	guest: IGuest;
	allGuest: any;
};

const GuestAndSpeakerTableRow = ({ guest, allGuest }: IProps) => {
	const theme = useTheme();

	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [open, setOpen] = useState<boolean>(false);
	const [deleteModal, setDeleteModal] = useState<boolean>(false);
	const { user } = useAuthContext();

	const imgSrc = useValidImage(guest?.guest_speaker_photo);

	const { mutate: deleteGuest, isPending } = useApiMutation<void, void>({
		method: "DELETE",
		endPoint: `/api/fair/for-admin/guest-or-speaker/delete-by/${guest.guest_speaker_id}?user_admin_id=${user.user_admin_id}`,
		invalidateQueries: ["Fairs"],
	});

	const handleDelete = () => {
		deleteGuest();
		setOpen(false);
	};

	return (
		<>
			<TableRow hover>
				<TableCell>
					<Typography
						variant="body1"
						color="text.primary"
						gutterBottom
						noWrap
					>
						{guest?.guest_speaker_id}
					</Typography>
				</TableCell>
				<TableCell>
					<Box sx={{ display: "flex", alignItems: "center" }}>
						<img
							width={30}
							height={30}
							style={{
								borderRadius: "50%",
								marginRight: "10px",
							}}
							src={imgSrc}
							alt={guest.guest_speaker_name}
						/>
					</Box>
				</TableCell>
				<TableCell>
					<Typography
						variant="body1"
						color="text.primary"
						gutterBottom
						noWrap
					>
						{guest?.guest_speaker_name
							.toLowerCase()
							.split(" ")
							.map(
								(word) =>
									word.charAt(0).toUpperCase() + word.slice(1)
							)
							.join(" ")}
					</Typography>
				</TableCell>

				<TableCell>
					<Typography
						variant="body1"
						color="text.primary"
						gutterBottom
						noWrap
					>
						{getStatusLabel(guest?.guest_speaker_status)}
					</Typography>
				</TableCell>
				<TableCell>
					<Typography
						variant="body1"
						color="text.primary"
						gutterBottom
						noWrap
					>
						{guest?.guest_speaker_type === "guest"
							? "Guest"
							: "Speaker"}
					</Typography>
				</TableCell>
				<TableActions
					showView
					viewLink={`/guest-speaker/guest-list/details/${guest?.guest_speaker_id}`}
				/>
			</TableRow>
		</>
	);
};

export default GuestAndSpeakerTableRow;
